"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestTopics = requestTopics;
exports.ADD_TOPIC_CLUSTERS = exports.SET_TOPIC_CLUSTERS_REQUEST_STATE = void 0;

var _TopicClusterApiClient = require("../api/TopicClusterApiClient");

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _RequestState = require("lead-flows-ui/utils/RequestState");

function createActionType(name) {
  return "@@topicClusters/" + name;
}

var SET_TOPIC_CLUSTERS_REQUEST_STATE = createActionType('SET_TOPIC_CLUSTERS_REQUEST_STATE');
exports.SET_TOPIC_CLUSTERS_REQUEST_STATE = SET_TOPIC_CLUSTERS_REQUEST_STATE;
var ADD_TOPIC_CLUSTERS = createActionType('ADD_TOPIC_CLUSTERS');
exports.ADD_TOPIC_CLUSTERS = ADD_TOPIC_CLUSTERS;

function setTopicClusterRequestState(requestState) {
  return {
    requestState: requestState,
    type: SET_TOPIC_CLUSTERS_REQUEST_STATE
  };
}

function addTopicClusters(topicClusters) {
  return {
    topicClusters: topicClusters,
    type: ADD_TOPIC_CLUSTERS
  };
}

function requestTopics() {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emptyFunction.default;
  return function (dispatch) {
    dispatch(setTopicClusterRequestState(_RequestState.REQUEST_SUBMITTED));
    (0, _TopicClusterApiClient.getClusters)(false).then(function (clusters) {
      dispatch(setTopicClusterRequestState(_RequestState.SUCCESS));
      dispatch(addTopicClusters(clusters));
      callback(clusters);
    }, function (_ref) {
      var xhr = _ref.xhr;
      console.log("Handle error " + xhr.status); // eslint-disable-line

      dispatch(setTopicClusterRequestState(_RequestState.ERROR));
    }).done();
  };
}